<template>
  <div class="feature">
    <img :alt="icon" :src="require(`../assets/images/${icon}.png`)">
    <p>{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: "Feature",
  props: {
    icon: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.feature {
  text-align: center;
  font-size: 2em;
  max-width: 20%;
  margin: 1em;
  height: 400px;
  width: 30%;
}

.feature img {
  border-bottom: 0.15em dotted #00c8b7;
  padding-bottom: 1em;
}

.feature p {
  padding-top: 1em;
}

@media only screen and (max-width: 800px) {
  .feature {
    width: 100%;

    max-width: 50%;
    margin-bottom: 2em;
  }
}
</style>
